import type { Locale } from "./dto";

/**
 * F116. The questionnaire's price question wrote `currency: "CZK"` into the
 * saved answer no matter who was typing, so an American client entering 2000
 * meant dollars and we stored crowns - and those crowns then travelled into
 * the brief the price list is built from. This is the one bug in the audit
 * that is not a wrong sentence but WRONG DATA, and it is silent: nothing on
 * the screen ever names the unit.
 *
 * The market decides the unit, so the mapping lives beside the market, once.
 */
export const MARKET_CURRENCY = { cs: "CZK", en: "USD" } as const;

export type MarketCurrency = (typeof MARKET_CURRENCY)[keyof typeof MARKET_CURRENCY];

export function marketCurrency(locale: Locale): MarketCurrency {
  return MARKET_CURRENCY[locale];
}

/**
 * Shape validation accepts EITHER of our currencies rather than the one this
 * client happens to be on: the validator's job is "is this a well-formed
 * value", and a closed two-item set is exactly that. Which of the two is right
 * for a given client is decided where the answer is written, from the server's
 * own `clients.market_language`.
 */
export function isMarketCurrency(value: unknown): value is MarketCurrency {
  return typeof value === "string" && (Object.values(MARKET_CURRENCY) as string[]).includes(value);
}
